import axios from 'axios';
import axiosAPI from '@/query/index';
import { Action, Dict, Member, Model, Robot, RobotBodyInfo, RobotTemplate, RobotTypes, Role, Scene, SceneMap, SceneTask, Timbre, VoicePrint } from '@/types/interface';
import { FormField } from '@/pages/voice-config/types';
import { SceneMarker } from '@/pages/scene-mg/scene-detail/interface';
export const API = {
  /** 查询用户列表 */
  getUserList: '/api/getUserList',
  /** 登出 */
  logout: '/ai-gateway/api/users/logout',
  /** 登录 */
  login: '/ai-gateway/api/users/login',
  /** 获取机器人列表 */
  getRobotList: '/ai-gateway/api/robots',
  /** 获取所有字典*/
  getDict: '/ai-gateway/api/dict',
  /** 获取角色列表 */
  getRoleList: '/ai-gateway/api/getRoleList',
  /** 获取模型列表 */
  getModelList: '/api/getModelList',
  /** 获取会员列表 */
  getMemberList: '/api/getMemberList',
  /** 任杰工具接口 */
  getMarkers: '/get_guide_words',
  /** 保存标记点 */
  saveMarkers: '/save_guide_words',
  // 获取机器人信息
  getRobotInfo: '/robot_info',

  timbre: '/ai-gateway/api/voice/timbre',
  /** 声纹BaseUrl */
  voicePrint: '/ai-gateway/api/voice/voiceprint',
  /** 获取音色或声纹文件 */
  getTimebreOrVoicePrintFile: '/ai-gateway/api/voice/file',

  // 基础路径（用于动态构建）
  robots: '/ai-gateway/api/robots',
  scenes: '/ai-gateway/api/scenes',
  sceneMap: '/ai-gateway/api/scene-maps',
  templates: '/ai-gateway/api/template',
  actions: '/ai-gateway/api/action-train',
  /** 获取教程链接 */
  getTutorialUrl: '/ai-gateway/api/config/tutorial',
  /** 获取验证码 */
  getSms: '/ai-gateway/api/users/send-sms',
  /** 手机号验证码登录 */
  loginSms: '/ai-gateway/api/users/login-sms',
  /** 获取购买记录 */
  getPurchaseHistory: '/ai-gateway/api/orders',
  /** 创建订单 */
  createOrder: '/ai-gateway/api/orders',
  /** 获取娱乐文旅列表 */
  getDanceActions: '/ai-gateway/api/skills',
   /** 获取舞蹈动作列表 */
  getHotSkills: '/ai-gateway/api/skills/hot',
  /** 绑定技能到机器人 */
  bindSkillToRobot: '/ai-gateway/api/skills/bind-robot',
};
/**
 * 动态API路径构建器
 */
export const API_PATHS = {
  //机器人配置
  getRobotModelConfig: (robotId: string) => `${API.robots}/${robotId}/config-mata`,
  setRobotModelConfig: (robotId: string) => `${API.robots}/${robotId}/model-config`,
  editRobotBasicInfo: (robotId: string) => `${API.robots}/${robotId}`,  /** 音色BaseUrl */
  getRobotContext: (robotId: string) => `${API.robots}/${robotId}/context`,
  getActionsByRobotId: (robotId: string) => `${API.robots}/${robotId}/actions`,
  //场景相关
  addSceneMap: () => `${API.scenes}/add-map`,
  delSceneMap: () => `${API.scenes}/delete-map`,
  getSceneDetail: (id: string) => `${API.scenes}/${id}`,
  bindRobots: (id: string) => `${API.scenes}/${id}/bind-robot`,
  delScene: (id: string) => `${API.scenes}/${id}`,
  //场景地图相关
  sceneMarkers: () => `${API.sceneMap}/points`,
  delSceneMarker: (id: string) => `${API.sceneMap}/points/${id}`,
  pgmFile: (id: string) => `${API.sceneMap}/${id}/pgm`,
  yamlFile: (id: string) => `${API.sceneMap}/${id}/yaml`,
  changeSceneMarkerOrder: () => `${API.sceneMap}/points/change-order`,
  //模板相关
  delTemplate: (id: string) => `${API.templates}/${id}`,
  addTemplateByRobot: () => `${API.templates}/by-robot`,
  //动作相关
  addToBody: (id: string) => `${API.actions}/${id}/add-to-body`,
  getActionProgress: (id: string) => `${API.actions}/${id}/progress`,
  startStrategyTrain: (id: string) => `${API.actions}/${id}/start-strategy-train`,
  stopTrain: (id: string) => `${API.actions}/${id}/stop-train`,
  trainDone: (id: string) => `${API.actions}/${id}/train-done`,
  action: (id: string) => `${API.actions}/${id}`,
  getRobotsByActionId: (actionId: string) => `${API.actions}/${actionId}/supported-robots`,
};

/**
 * 接口请求成功时的响应类型
 */
type ResponseSuccess<T> = {
  data: {
    success: boolean;
    code: number;
    data: T;
    msg: string;
  };
};

export type LoginRequest = {
  name: string;
  pass: string;
}

/**
 * 登录
 * @param requestData
 * @returns
 */
export function login(requestData: LoginRequest): Promise<ResponseSuccess<string>> {
  return axiosAPI.post(API.login, null, {
    params: requestData,
  });
}


type LogoutRequest = {
  systemCode: string;
};

/**
 * 登出
 * @param requestData
 * @returns
 */
export function logout(): Promise<ResponseSuccess<null>> {
  return axiosAPI.get(API.logout);
}

export type GetRobotListRequest = {
  id?: string;
  pageSize?: number;
  pageIndex?: number;
  searchText?: string;
  searchType?: number;
}


export function getRobotList(): Promise<ResponseSuccess<Robot[]>> {
  return axiosAPI.get(API.getRobotList);
}


export function getDict(): Promise<ResponseSuccess<Dict>> {
  return axiosAPI.get(API.getDict);
}

export type EditRobotRequest = {
  robotId: string,
  robotInfo: Robot
}

export function editRobotBasicInfo(requestData: EditRobotRequest): Promise<ResponseSuccess<null>> {
  return axiosAPI.post(API_PATHS.editRobotBasicInfo(requestData.robotId),
    requestData.robotInfo
    // actions: requestData.robotInfo.actions.reduce((acc: Record<string, string>, item: Action) => {
    //   if (item.name && item.id) {
    //     acc[item.name] = item.id;
    //   }
    //   return acc;
    // }, {})
  );
}

export type GetRobotContextRequest = {
  robotId: string;
}

export function getRobotContext(requestData: GetRobotContextRequest): Promise<ResponseSuccess<RobotBodyInfo>> {
  return axiosAPI.get(API_PATHS.getRobotContext(requestData.robotId));
}

export type GetRoleListRequest = {
  id?: string;
  pageSize?: number;
  pageIndex?: number;
  searchText?: string;
  searchType?: number;
}

export type GetRoleListResponse = {
  total: number;
  list: Role[];
}

export function getRoleList(requestData: GetRoleListRequest): Promise<ResponseSuccess<GetRoleListResponse>> {
  return axiosAPI.post(API.getRoleList, requestData);
}

export type GetModelListRequest = {
  id?: string;
  pageSize?: number;
  pageIndex?: number;
  searchText?: string;
  searchType?: number;
}

export type GetModelListResponse = {
  total: number;
  list: Model[];
}

export function getModelList(requestData: GetModelListRequest): Promise<ResponseSuccess<GetModelListResponse>> {
  return axiosAPI.post(API.getModelList, requestData);
}


export type updateRobotListRequest = {
  id?: string;
  name?: string;
  type?: string;
  searchType?: number;
  skills: string[];
}


export function updateRobotList(requestData: updateRobotListRequest): Promise<ResponseSuccess<any>> {
  return axiosAPI.put(API.getRobotList, requestData);
}

export type GetMemberListRequest = {
  id?: string;
  pageSize?: number;
  pageIndex?: number;
  searchText?: string;
  searchType?: number;
}

export type GetMemberListResponse = {
  total: number;
  list: Member[];
}

export function getMemberList(requestData: GetMemberListRequest): Promise<ResponseSuccess<GetMemberListResponse>> {
  return axiosAPI.post(API.getMemberList, requestData);
}


export type GetRobotModelConfigRequest = {
  robotId: string;
}

/**
 * 获取机器人模型配置
 * @param requestData
 * @returns
 */
export function getRobotModelConfig(requestData: GetRobotModelConfigRequest): Promise<ResponseSuccess<FormField[]>> {
  return axiosAPI.get(API_PATHS.getRobotModelConfig(requestData.robotId));
}

export type SetRobotModelConfigRequest = {
  robotId: string;
  config: FormField[];
}

export function setRobotModelConfig(requestData: SetRobotModelConfigRequest): Promise<ResponseSuccess<null>> {
  return axiosAPI.post(API_PATHS.setRobotModelConfig(requestData.robotId), requestData.config);
}


export function getTimbreList(): Promise<ResponseSuccess<Timbre[]>> {
  return axiosAPI.get(API.timbre);
}

export type AddTimbreRequest = {
  name?: string;
  gender?: number,
  file?: File,
}

export function addTimbre(requestData: AddTimbreRequest): Promise<ResponseSuccess<null>> {
  return axiosAPI.post(API.timbre, requestData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    }
  });
}
export type DelTimbreRequest = {
  id?: string;
}

export function delTimbre(requestData: DelTimbreRequest): Promise<ResponseSuccess<null>> {
  return axiosAPI.delete(API.timbre, {
    params: requestData,
  });
}

export function getVoicePrintList(): Promise<ResponseSuccess<VoicePrint[]>> {
  return axiosAPI.get(API.voicePrint);
}

export type AddVoicePrintRequest = {
  name?: string;
  file?: File,
}

export function addVoicePrint(requestData: AddVoicePrintRequest): Promise<ResponseSuccess<null>> {
  return axiosAPI.post(API.voicePrint, requestData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    }
  });
}

export type DelVoicePrintRequest = {
  id?: string;
}

export function delVoicePrint(requestData: DelVoicePrintRequest): Promise<ResponseSuccess<null>> {
  return axiosAPI.delete(API.voicePrint, {
    params: requestData,
  });
}

export type GetVoiceFileRequest = {
  id?: string;
  type?: string;
}

export function getVoiceFile(requestData: GetVoiceFileRequest): Promise<ResponseSuccess<Blob>> {
  return axiosAPI.get(API.getTimebreOrVoicePrintFile, {
    params: requestData,
    responseType: 'blob',
  });
}

export function getSceneList(): Promise<ResponseSuccess<Scene[]>> {
  return axiosAPI.get(API.scenes);
}

export type SceneRequest = {
  id: string,
  name: string,
  description: string,
  status: string,
  mapIds: string[],
};

export function addScene(requestData: SceneRequest): Promise<ResponseSuccess<null>> {
  return axiosAPI.post(API.scenes, requestData);
}

export function editScene(requestData: SceneRequest): Promise<ResponseSuccess<null>> {
  return axiosAPI.put(API.scenes, requestData);
}

export function delScene(id: string): Promise<ResponseSuccess<null>> {
  return axiosAPI.delete(API_PATHS.delScene(id));
}

export type GetSceneDetailResponse = {
  robots: Robot[],
  sceneMap: Record<string, string>,
};

export function getSceneDetail(id: string): Promise<ResponseSuccess<GetSceneDetailResponse>> {
  return axiosAPI.get(API_PATHS.getSceneDetail(id));
}

// export function delScene()

export type AddSceneMapRequest = {
  name?: string,
  pcdFile?: File,
  pgmFile?: File,
  yamlFile?: File,
}

export function addSceneMap(requestData: AddSceneMapRequest): Promise<ResponseSuccess<string>> {
  return axiosAPI.post(API_PATHS.addSceneMap(), requestData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    }
  });
}

export type DelSceneMapRequest = {
  id: string
}

export function delSceneMap(requestData: DelSceneMapRequest): Promise<ResponseSuccess<null>> {
  return axiosAPI.delete(API_PATHS.delSceneMap(), { params: requestData });
}

export type BindRobotToSceneRequest = {
  sceneId: string,
  robots: Robot[],
}

export function bindRobotToScene(requestData: BindRobotToSceneRequest): Promise<ResponseSuccess<null>> {
  const robotRequestBody = requestData.robots.map((robot) => ({
    robotId: robot.id,
    mapId: robot.mapId,
    mapName: robot.mapName,
  }));
  return axiosAPI.post(API_PATHS.bindRobots(requestData.sceneId), robotRequestBody);
}

export function getPgmFile(id: string): Promise<ResponseSuccess<Blob>> {
  return axiosAPI.get(API_PATHS.pgmFile(id), {
    responseType: 'blob',
  });
}

export type SetPgmFileRequest = {
  id: string,
  file: File,
}

export function setPgmFile(requestData: SetPgmFileRequest): Promise<ResponseSuccess<null>> {
  const formData = new FormData();
  formData.append('file', requestData.file);

  return axiosAPI.put(API_PATHS.pgmFile(requestData.id), formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    }
  });
}

export function getYamlFile(id: string): Promise<ResponseSuccess<Blob>> {
  return axiosAPI.get(API_PATHS.yamlFile(id), {
    responseType: 'blob',
  });
}

export interface MarkerModel {
  id: string;
  sceneId?: string;//关联的场景
  name?: string;
  description?: string;
  yaw?: number;
  cxx?: number;
  cxy?: number;
  cxz?: number;
  tasks?: SceneTask[];
  x?: number;
  y?: number;
  z?: number;
}

// 获取地图上的所有标记点
export function getMarkers(sceneId: string): Promise<ResponseSuccess<MarkerModel[]>> {
  return axiosAPI.get(API_PATHS.sceneMarkers(), { params: { sceneId } });
}

// 添加地图上的标记点
export function addMarker(requestData: MarkerModel): Promise<ResponseSuccess<null>> {
  return axiosAPI.post(API_PATHS.sceneMarkers(), requestData);
}

export function editMarker(requestData: MarkerModel): Promise<ResponseSuccess<null>> {
  return axiosAPI.put(API_PATHS.sceneMarkers(), requestData);
}

// 删除地图上的标记点
export function delMarker(id: string): Promise<ResponseSuccess<null>> {
  return axiosAPI.delete(API_PATHS.delSceneMarker(id));
}

export function changeSceneMarkerOrder(pointIds: string[]): Promise<ResponseSuccess<null>> {
  return axiosAPI.put(API_PATHS.changeSceneMarkerOrder(), pointIds);
}

export function getTemplateList(): Promise<ResponseSuccess<RobotTemplate[]>> {
  return axiosAPI.get(API.templates);
}

export type TemplateRequest = {
  id?: string;
  name?: string;
  description?: string;
  detail?: any;
  robotType?: string;
  role?: string;
  roleName?: string;
  timbre?: string;
}

export function addTemplate(requestData: TemplateRequest): Promise<ResponseSuccess<null>> {
  return axiosAPI.post(API.templates, requestData);
}

export type AddTemplateByRobotRequest = {
  name?: string;
  description?: string;
  robotId?: string;
}

export function addTemplateByRobot(requestData: AddTemplateByRobotRequest): Promise<ResponseSuccess<null>> {
  return axiosAPI.post(API_PATHS.addTemplateByRobot(), requestData);
}

export function editTemplate(requestData: TemplateRequest): Promise<ResponseSuccess<null>> {
  return axiosAPI.put(API.templates, requestData);
}

export function delTemplate(id: string): Promise<ResponseSuccess<null>> {
  return axiosAPI.delete(API_PATHS.delTemplate(id));
}

//动作相关
export function getActionList(): Promise<ResponseSuccess<Action[]>> {
  return axiosAPI.get(API.actions);
}

export function getActionsByRobotId(robotId: string): Promise<ResponseSuccess<Action[]>> {
  return axiosAPI.get(API_PATHS.getActionsByRobotId(robotId));
}

export type startRedirectRequest = {
  name: string;
  description: string;
  specs: string;
  video: File;
}

export function startRedirect(requestData: startRedirectRequest): Promise<ResponseSuccess<string>> {
  return axiosAPI.post(API.actions, requestData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    }
  });
}

export function getActionDetail(id: string): Promise<ResponseSuccess<Action>> {
  return axiosAPI.get(API_PATHS.action(id));
}

type EditActionRequest = {
  id: string;
  [key: string]: any;
}

export function editAction(requestData: EditActionRequest): Promise<ResponseSuccess<null>> {
  return axiosAPI.put(API_PATHS.action(requestData.id), null, { params: { name: requestData.name, description: requestData.description } });
}

export function delAction(id: string): Promise<ResponseSuccess<null>> {
  return axiosAPI.delete(API_PATHS.action(id));
}

export type addToBodyRequest = {
  id: string;
  robotIds: string;
}

export function addToBody(requestData: addToBodyRequest): Promise<ResponseSuccess<null>> {
  return axiosAPI.post(API_PATHS.addToBody(requestData.id), null, { params: { robotIds: requestData?.robotIds } });
}

export type getActionProgressResponse = {
  progress: number;
  leftTime: number;
  fileUrl: string;
}

export function getActionProgress(id: string): Promise<ResponseSuccess<getActionProgressResponse>> {
  return axiosAPI.get(API_PATHS.getActionProgress(id));
}

export function startStrategyTrain(id: string): Promise<ResponseSuccess<null>> {
  return axiosAPI.post(API_PATHS.startStrategyTrain(id));
}

export function stopTrain(id: string): Promise<ResponseSuccess<null>> {
  return axiosAPI.post(API_PATHS.stopTrain(id));
}

export function trainDone(id: string): Promise<ResponseSuccess<null>> {
  return axiosAPI.post(API_PATHS.trainDone(id));
}

export function getRobotsByActionId(actionId: string): Promise<ResponseSuccess<Robot[]>> {
  return axiosAPI.get(API_PATHS.getRobotsByActionId(actionId));
}

export function getTutorialUrl(): Promise<ResponseSuccess<string>> {
  return axiosAPI.get(API.getTutorialUrl);
}

export type GetSmsRequest = {
  mobile: string;
}

export function getSms(requestData: GetSmsRequest): Promise<ResponseSuccess<string>> {
  return axiosAPI.get(API.getSms, { params: requestData });
}

export type LoginSmsRequest = {
  mobile: string;
  sms: string;
}

export function loginSms(requestData: LoginSmsRequest): Promise<ResponseSuccess<string>> {
  return axiosAPI.post(API.loginSms, null, { params: requestData });
}
// 购买记录相关
export function getPurchaseHistory(): Promise<ResponseSuccess<any[]>> {
  return axiosAPI.get(API.getPurchaseHistory);
}

// 娱乐文旅相关
export type GetDanceActionsRequest = {
  specs?: string;
}

export function getDanceActions(requestData?: GetDanceActionsRequest): Promise<ResponseSuccess<any[]>> {
  return axiosAPI.get(API.getDanceActions, { params: requestData });
}

export function getHotSkills(requestData?: GetDanceActionsRequest): Promise<ResponseSuccess<any[]>> {
  return axiosAPI.get(API.getHotSkills, { params: requestData });
}

// 获取单个技能详情
export function getSkillDetail(skillId: string): Promise<ResponseSuccess<any>> {
  return axiosAPI.get(`${API.getDanceActions}/${skillId}`);
}

// 订单相关
export type CreateOrderRequest = {
  skillId: string;
  quantity: number;
}

export function createOrder(requestData: CreateOrderRequest): Promise<ResponseSuccess<any>> {
  return axiosAPI.post(API.createOrder, requestData);
}

// 获取订单状态
export function getOrderStatus(orderId: string): Promise<ResponseSuccess<number>> {
  return axiosAPI.get(`/ai-gateway/api/orders/${orderId}/order-status`);
}

// 获取订单详情
export function getOrderDetail(orderId: string): Promise<ResponseSuccess<any>> {
  return axiosAPI.get(`/ai-gateway/api/orders/${orderId}`);
}

// 技能机器人相关
export type GetSkillRobotsRequest = {
  skillId: string;
}

export type SkillRobot = {
  robotId: string;
  robotName: string;
  robotSpecs: string;
  createTime: string;
  bound: boolean;
}

export function getSkillRobots(requestData: GetSkillRobotsRequest): Promise<ResponseSuccess<SkillRobot[]>> {
  return axiosAPI.get('/ai-gateway/api/skills/robots', { params: requestData });
}

// 绑定技能到机器人
export type BindSkillToRobotRequest = {
  skillId: string;
  robotId: string;
};

export function bindSkillToRobot(requestData: BindSkillToRobotRequest): Promise<ResponseSuccess<string>> {
  return axiosAPI.post(API.bindSkillToRobot, requestData);
}
// 注册相关
export type RegisterRequest = {
  email: string;
  pass: string;
  code: string;
}

export function register(requestData: RegisterRequest): Promise<ResponseSuccess<null>> {
  return axiosAPI.post('/ai-gateway/api/users/register-by-email', null, {
    params: requestData,
  });
}
// export function login(requestData: LoginRequest): Promise<ResponseSuccess<string>> {
//   return axiosAPI.post(API.login, null, {
//     params: requestData,
//   });
// }

export type GetEmailCodeRequest = {
  email: string;
}

// getSms, loginSms, etc...

export function getEmailCode(requestData: GetEmailCodeRequest): Promise<ResponseSuccess<null>> {
   // Placeholder API path
  return axiosAPI.get('/ai-gateway/api/users/send-sms-email', { params: requestData });
}

export function getSdk(): Promise<ResponseSuccess<string>> {
  return axiosAPI.get('/ai-gateway/api/get-sdk');
}